import React, { useState } from "react";
import { MGText } from "../MGText";
import { MGMicrotext } from "../MGMicrotext";
import { MGDocumentListItem } from "./MGDocumentListItem";
import { TMGDocumentListProps } from "./MGDocumentList.types";
import styles from "./MGDocumentList.module.css";

let nextListId = 0;

export const MGDocumentList = ({
  data,
  title,
  titleTag = "h2",
  "aria-label": ariaLabel,
  alignment = "vertical",
  appearance = "white",
  className,
  style,
  dataTestId,
  loading = false,
  loadingNextPage = false,
  skeletonProps,
  emptyText = "Sem documentos disponiveis.",
  loadingText = "A carregar documentos...",
}: TMGDocumentListProps) => {
  const [titleId] = useState(() => `mg-document-list-${++nextListId}-title`);
  const busy = loading || loadingNextPage;
  const number = skeletonProps?.number === undefined ? 6 : skeletonProps.number;
  const skeletonCount = Number.isFinite(number) ? Math.max(0, Math.floor(number)) : 6;

  return (
    <section
      className={`${styles.root} ${className || ""}`}
      style={style}
      data-alignment={alignment}
      data-testid={dataTestId}
      aria-labelledby={title && !ariaLabel ? titleId : undefined}
      aria-label={ariaLabel || (!title ? "Documentos" : undefined)}>
      {title && (
        <MGText
          tagName={titleTag}
          textStyleDefinition="body-200-05"
          id={titleId}
          className={styles.title}>
          {title}
        </MGText>
      )}
      {/* Preserve list semantics in Safari when list markers are removed. */}
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul
        className={styles.list}
        role="list"
        aria-busy={busy}
        aria-label={title || ariaLabel || "Documentos"}>
        {!loading &&
          data.map((item, index) => (
            <li key={item.id || `${item.name}-${index}`} className={styles.listItem}>
              <MGDocumentListItem {...item} appearance={appearance} />
            </li>
          ))}
        {busy &&
          Array.from({ length: skeletonCount }, (_, index) => (
            <li
              key={`skeleton-${index}`}
              className={styles.skeleton}
              aria-hidden="true"
              style={{ height: skeletonProps?.height === undefined ? 120 : skeletonProps.height }}
              data-testid={dataTestId && `${dataTestId}-skeleton`}>
              <span />
              <span />
              <span />
            </li>
          ))}
      </ul>
      <span className={styles.srOnly} role="status">
        {busy ? loadingText : ""}
      </span>
      {!busy && data.length === 0 && (
        <MGMicrotext
          tagName="p"
          microtextStyleDefinition="microcopy-100-03"
          color="text-primary-03"
          className={styles.empty}>
          {emptyText}
        </MGMicrotext>
      )}
    </section>
  );
};
